<template>
  <div>
    <b-table ref="usersTable" responsive striped :fields="fields" :items="dataProvider" :per-page="perPage"
      :current-page="currentPage">
      <template #cell(user)="row">
        {{ row.item.user.username }}
      </template>
      <template #cell()="row">
        <div v-if="isView || rowNumber != row.index">
        <b-icon icon="check-circle" style="color: green" title="sì" v-if="row.item.lunchTicket[row.field.key].lunchTicket" />
        <b-icon icon="x-circle" style="color: red" title="no" v-else />
        </div>
        <div v-else>
          <b-form>
            <b-form-checkbox v-model="lunchTicketReport[row.field.key]" @change="changeColumnValue(row.field.key)"></b-form-checkbox>
          </b-form>
        </div>
      </template>
      <template #cell(actions)="row">
        <div v-if="!isView && rowNumber == row.index">
          <b-button size="sm" @click="save()" title="Salva" class="mr-2">
            Salva
          </b-button>
           <b-button size="sm" @click="cancel" title="Cancella" class="mr-2">
            Annulla
          </b-button>
        </div>
        <div v-else>
          <b-button size="sm" @click="editMode(row)" title="Modifica" class="mr-2">
            <b-icon icon="brush"></b-icon>
          </b-button>
        </div>
      </template>
    </b-table>
    <b-pagination v-model="currentPage" :total-rows="rows" :per-page="perPage"></b-pagination>
  </div>
</template>

<script>
import lunchTicketService from '@/services/lunchTicketService'

export default {
  created() {
    this.generateTableHeaders()
  },
  data() {
    return {
      isView: true,
      rowNumber: -1,
      lunchTicketReport: [],
      columnsEdited: new Set(),
      employee: null,
      currentPage: 1,
      perPage: 50,
      rows: 0,
      fields: []
    }
  },
  computed: {
    filter() {
      return this.$store.getters.lunchTicketFilter
    }
  },
  watch: {
    filter: {
      handler: function() {
        this.generateTableHeaders()
        this.$refs.usersTable.refresh();
      }
    }
  },
  methods: {
    dataProvider(ctx) {
      return lunchTicketService.fetchUsers(ctx, this.filter)
        .then(page => {
          this.rows = page.totalElements
          return page.content
        })
    },
    generateTableHeaders() {
      const datesInMonth = (year, month) => {
        const date = new Date(year, month, 1);
        const days = [];
        while (date.getMonth() === month) {
          days.push(new Date(date));
          date.setDate(date.getDate() + 1);
        }
        return days;
      }
      this.fields = datesInMonth(this.filter.year, this.filter.month - 1).map(date => {
        const sunday = 0
        const saturday = 6
        const variant = (date.getDay() === sunday || date.getDay() === saturday) ? 'secondary' : 'light'
        return { key: `${date.getDate() - 1}`, label: `${date.getDate()}`, variant: variant }
      })
      this.fields.unshift({ key: 'user', label: 'Username' }) // first field
      this.fields.push({ key: 'actions', label: 'Azioni' })
    },
    editMode(row) {
      this.isView = false
      this.lunchTicketReport = row.item.lunchTicket.map(e => e.lunchTicket)
      this.employee = row.item.user.id
      this.rowNumber = row.index
    },
    changeColumnValue(columnId) {
      this.columnsEdited.add(columnId)
    },
    save() {
      lunchTicketService.save(this.filter.year, this.filter.month, this.employee, this.lunchTicketReport, Array.from(this.columnsEdited))
        .then(() => {
          this.cancel()
          this.$refs.usersTable.refresh();
        })
    },
    cancel() {
      this.isView = true
      this.rowNumber = -1
      this.lunchTicketReport = []
      this.employee = null
      this.columnsEdited = new Set()
    }
  }
}
</script>
